import { render } from "./Carousel.vue?vue&type=template&id=42bac093"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=42bac093&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\landing-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__